/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FetchRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {FetchResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const fetch = (request:FetchRequest, options?: CashRequestOptions) => post<FetchRequest, FetchResponse>("/2.0/cash/fetch", request, {...options, rejectOnError: true })